import { B2BSubnav, parseSubnavItems } from '@zillow/zrs-cms';
import React from 'react';

interface MenuItem {
    id: string | number;
    title: { rendered: string; raw?: string };
    url: string;
    parent: string | number;
}

interface LearningCenterSubnavProps {
    menu: {
        items: MenuItem[];
    };
}

const LearningCenterSubnav: React.FC<LearningCenterSubnavProps> = ({
    menu,
}) => {
    // Transform menu data to B2BSubnav format (only top-level items)
    const subnavItems = parseSubnavItems(menu?.items || []);

    return (
        <B2BSubnav
            primaryItem={{
                id: 0,
                title: 'Learning Center',
                url: '/learn/',
                parent: 0,
            }}
            items={subnavItems}
            searchPrefix="/learn/search/"
            searchPlaceholder="Search Learning Center"
        />
    );
};

export default LearningCenterSubnav;
